module.exports = __webpack_public_path__ + "img/9788959522712.972c97db.jpg";